/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { navigate } from '@hfzq/crab-utils';
import { MenuType } from '@hfzq/crab-utils/esm/utils/navigation/helper';
import { createExtraRoute } from '../helper/extra-factory';

type ProdCodeQuery = {
  /** 产品代码 */
  prodCode: string;
  /** 产品名称 */
  prodName?: string;
  /** 是否从风险产品签署列表页跳转 1:是 */
  isR5?: number;
};

// 理财商城首页
export const MallHomeRouteExtra = () => {
  navigate('http://action:1035/');
};

type RegularEarlyRepurchaseRouteExtraQuery = {
  /** 产品代码 */
  stockcode: string;
  /**  */
  prodate: string;
  /** 产品TA */
  prono: string;
};

type RegularEarlyRepurchaseRouteExtraParams = {
  BJHGTQGH: {
    /** 产品名称 */
    name: string;
    /** 产品代码 */
    code: string;
    /** 提前年收益率 */
    ydnhsyl: string;
    /** 持仓成本 */
    val: string;
  };
};

// 定期-报价回购提前购回
export const RegularEarlyRepurchaseRouteExtra = createExtraRoute<
  RegularEarlyRepurchaseRouteExtraQuery,
  RegularEarlyRepurchaseRouteExtraParams
>('/mall/bjhgTitiangouhuiInput.html');

// 公募基金-可用份额
export const AvailableSharesRouteExtra = createExtraRoute<ProdCodeQuery>(
  '/mall/ccProductDetail/ccProductRedeemDetail.html'
);

type FundDetailRouteExtraQuery = ProdCodeQuery & {
  /** 产品TA */
  prodtaNo: string;
  /** 分红类型 */
  fhflag: string;
};

// 公募基金-分红方式
export const ShareBonusMethodRouteExtra = createExtraRoute<FundDetailRouteExtraQuery>('/mall/xgfhfs.html');

type MutualRedemptionRouteExtraQuery = ProdCodeQuery & {
  /** 是否是限定日期赎回型基金 */
  isSpecialJJ?: 1;
};

// 公募基金-赎回
export const MutualRedemptionRouteExtra =
  createExtraRoute<MutualRedemptionRouteExtraQuery>('/mall/huoqi/cpshuhui.html');

type ExchangeRouteExtraQuery = ProdCodeQuery & {
  /** 产品名称 */
  prodName: string;
  /** 产品TA */
  prodTa: string;
  /** 申请编号 */
  allotno: string;
};

// 公募基金-转换
export const ExchangeRouteExtra = createExtraRoute<ExchangeRouteExtraQuery>('/mall/jjTransformation.html');

type ReviseMutualAutoInvestmentRouteExtraQuery = {
  pageSource: 'M';
};

type ReviseMutualAutoInvestmentRouteExtraParams = {
  DT_DETAIL: {
    prodCode: string;
    prodName: string;
    rectionType: string; // 定投期满类型
    payUnit: string; // 扣款周期单位 周/月
    payRate: string; // 扣款周期频率 每
    payDate: string; // 扣款允许日 某一天
    amount: string; // 发生金额
    beginDate: string; // 开始日期
    endDate: string; // 结束日期
    sendNo: string; // 申请编号
  };
};

type ProdCodeKhdQuery = {
  /** 产品代码 */
  prodCode: string;
  /** 产品名称 */
  prodName: string;
  /** 是否从风险产品签署列表页跳转 1:是 */
  isR5?: number;
};

// 公募基金-修改定投
export const ReviseMutualAutoInvestmentRouteExtra = createExtraRoute<
  ReviseMutualAutoInvestmentRouteExtraQuery,
  ReviseMutualAutoInvestmentRouteExtraParams
>('/mall/jjdingtou.html');

// 公募基金-申购
export const MutualPurchaseRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/jjshengou.html');

// 公募基金-申购快买
export const MutualPurchaseKhdRouteExtra = createExtraRoute<ProdCodeKhdQuery>('/mall/jjshengou_khd.html');
// 公募基金-认购快买
export const MutualSubscriptionKhdRouteExtra = createExtraRoute<ProdCodeKhdQuery>('/mall/huoqi/jjrengou_khd.html');

// 公募基金-认购
export const MutualSubscriptionRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/huoqi/jjrengou.html');

type MutualAutoInvestmentRouteExtraQuery = ProdCodeQuery & {
  /** 产品名称 */
  prodName: string;
};
// 公募基金-定投
export const MutualAutoInvestmentRouteExtra =
  createExtraRoute<MutualAutoInvestmentRouteExtraQuery>('/mall/jjdingtou.html');

// 资管产品-申购详情页
export const AssetManagementPurchaseRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/zgSGProductDetail.html', {
  tztadjustnever: 1,
  tzthiddentitle: 1,
});

// 资管产品-认购详情页
export const AssetManagementSubscriptionRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/zgRGProductDetail.html', {
  tztadjustnever: 1,
  tzthiddentitle: 1,
});

// 私募产品-申购详情页
export const PrivatePlacementPurchaseRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/smSGProductDetail.html', {
  tztadjustnever: 1,
  tzthiddentitle: 1,
});

// 私募产品-认购详情页
export const PrivatePlacementSubscriptionRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/smRGProductDetail.html', {
  tztadjustnever: 1,
  tzthiddentitle: 1,
});

type PrivatePlacementRedemptionRouteExtraQuery = ProdCodeQuery & {
  /** 赎回份额 */
  prodValue: string;
  /** 是否私募产品 */
  isSM: 1;
};
// 私募产品-赎回
export const privatePlacementRedemptionRouteExtra =
  createExtraRoute<PrivatePlacementRedemptionRouteExtraQuery>('/mall/huoqi/cpshuhui.html');

// type MutualAutoInvestmentZoneRouteExtraQuery = {
//   columnName?: string;
// };
// // 定投专区
// export const MutualAutoInvestmentZoneRouteExtra =
//   createExtraRoute<MutualAutoInvestmentZoneRouteExtraQuery>('/mall/mallDingTouIndex.html');

// 定投排行
export const MutualAutoInvestmentRankRouteExtra = createExtraRoute('/mall/mallDingTouPaiHang.html');

type PrivatePlacementRevisitRouteExtraQuery = ProdCodeQuery & {
  /** 委托编号 */
  contactid: string;
  /** 委托日期 */
  date: string;
};
// 私募基金回访问卷页面
export const PrivatePlacementRevisitRouteExtra = createExtraRoute<PrivatePlacementRevisitRouteExtraQuery>(
  '/mall/questionnaireFollowUp.html'
);

type AssetManagementRevisitRouteExtraQuery = PrivatePlacementRevisitRouteExtraQuery & {
  /** 申请编号 */
  allotNo: string;
};
// 资管回访问卷页面
export const AssetManagementRevisitRouteExtra =
  createExtraRoute<AssetManagementRevisitRouteExtraQuery>('/mall/zgRevisitQuestion.html');

type RegularRepoBackDetailModifyExpireRouteExtraQuery = {
  urlData: string;
};
// 报价回购修改到期续作
export const RegularRepoBackDetailModifyExpireRouteExtra =
  createExtraRoute<RegularRepoBackDetailModifyExpireRouteExtraQuery>('/mall/editDqxz.html');

// 场内基金-申购
export const OnsiteFundPurchaseRouteExtra = createExtraRoute<ProdCodeQuery>('/jy/cnjj/cnjj_shengou.html');

// 场内基金-认购
export const OnsiteFundSubscriptionRouteExtra = createExtraRoute<ProdCodeQuery>('/jy/cnjj/cnjj_rengou.html');

// ETF基金-申购
export const EtfFundPurchaseRouteExtra = createExtraRoute<ProdCodeQuery>('/jy/etf/etf_shengou.html');

// ETF基金-现金认购
export const EtfFundSubscriptionRouteExtra = createExtraRoute<ProdCodeQuery>('/jy/etf/etf_wxxjrg.html');

// 私募资管买入页面
export const HighEndFinanceBuyRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/jjBuy.html');

// 资管承诺函页面
export const AssetManagementCommitmentRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/zgCommitmentContent.html');

// 私募承诺函页面
export const privateEquityCommitmentRouteExtra = createExtraRoute<
  ProdCodeQuery & { isFirstBuy: number; isMeishi?: number; fixedFundCode?: 'Y' | 'N' }
>('/mall/smCommitmentContent.html');

// 私募承诺函页面
export const privateEquityCommitmentTTDRouteExtra = createExtraRoute<
  ProdCodeQuery & { isFirstBuy: number; orderNo?: string; useTTDSdk?: string }
>('/mall/smCommitmentContentTTD.html');

// 私募承诺函妥妥递页面
export const privateEquityCommitmentTTD2RouteExtra = createExtraRoute<ProdCodeQuery & { isFirstBuy: number }>(
  '/mall/smCommitmentTTDContent.html'
);

// 机构资管承诺函页面
export const JgAssetManagementCommitmentRouteExtra = createExtraRoute<ProdCodeQuery>(
  '/mall/zgjgCommitmentContent.html'
);

type HistoryNetValueRouteExtraQuery = ProdCodeQuery & {
  /** TA */
  prodtaNo: string;
  /** 产品名称 */
  prodName: string;
};
// 历史净值
export const HistoryNetValueRouteExtra =
  createExtraRoute<HistoryNetValueRouteExtraQuery>('/mall/smHistoryNetValue.html');

// 产品公告
export const AnnouncementRouteExtra = createExtraRoute<ProdCodeQuery>('/mall/smAnnouncement.html');

// 基金自选列表
export const FundSelectedListRouteExtra = createExtraRoute('/mall/jjZiXuanList.html');

// 定投学堂
export const FixedInvestmentSchoolRouteExtra = createExtraRoute('/mall/mallDingTouXueTang.html');

type FinancialManagementSchoolRouteExtraQuery = {
  lczxtabflag: 'LCZX-RM' | 'LCZX-XT';
  columnName: string;
};

// 理财学堂
export const FinancialManagementSchoolRouteExtra =
  createExtraRoute<FinancialManagementSchoolRouteExtraQuery>('/mall/mallLiCaiZiXun.html');

type FinancialManagementNewsRouteExtraQuery = {
  infoID: string;
};

// 理财资讯
export const FinancialManagementNewsRouteExtra = createExtraRoute<FinancialManagementNewsRouteExtraQuery>(
  '/mall/mallLiCaiZiXunXiangQing.html',
  {
    tztadjustnever: 1,
    tzthiddentitle: 1,
  }
);

type BJHGSaodanDetailRouteExtra = {
  stockCode: string;
};

// 报价回购扫单详情
export const BJHGSaodanDetailRouteExtra = createExtraRoute<BJHGSaodanDetailRouteExtra>('/mall/bjhgSaodanDetail.html', {
  tztadjustnever: 1,
  tzthiddentitle: 1,
});

type BJHGBuyRouteExtraQuery = {
  stockCode: string;
  prodTags: string;
  prodName: string;
};

// 报价回购扫单详情
export const BJHGBuyRouteExtra = createExtraRoute<BJHGBuyRouteExtraQuery>('/mall/bjhgBuyInput.html', {});

type FundMarketRouteExtra = {
  columnName: string;
};

// 基金超市
export const FundMarketRouteExtra = createExtraRoute<FundMarketRouteExtra>('/mall/znxj_product.html');

// 银证转账
export const YZINDEXRouteExtra = createExtraRoute('/jy/dyhzz/yz_index.html', {
  secondtype: MenuType.CUSTOM_SET_DEFAULT_IMG,
  secondtext: '户内转账',
  secondjsfuncname: 'tztPageSecodeFun()',
});

// 自助回访
export const ReturnVisitRouteExtra = createExtraRoute('/mall/zzhfIndex.html');

type RevisitQuestionRouteExtraQuery = {
  prodCode: string;
  date: string;
  time: string;
  allotNo: string;
  contactid?: string;
  returnCode?: string;
  fromSource?: string;
};
// 自助回访问卷
export const RevisitQuestionRouteExtra = createExtraRoute<RevisitQuestionRouteExtraQuery>(
  '/mall/newRevisitQuestion.html'
);

// 银证转账
export const BankSecuritiesTransferExtra = createExtraRoute('/jy/dyhzz/yz_index.html');
type RevisitHighRiskQuestionRouteExtraQuery = {
  prodCode: string;
  prodName: string;
  date: string;
  time: string;
  allotNo: string;
  contactid?: string;
  returnCode?: string;
};
// 高风险问卷
export const RevisitHighRiskQuestionRouteExtra = createExtraRoute<RevisitHighRiskQuestionRouteExtraQuery>(
  '/mall/jjHighRiskRevisitQuestion.html'
);
